import React, { useEffect } from "react";
import { CloseButton, ModalContent, ModalWrapper } from "./Modal.style";
import close from "./../../assets/images/close.png";

const Modal = ({ children, isOpen, setIsOpen, onClose = () => { } }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflowY = "hidden";
    }
    return () => {
      document.body.style.overflowY = "auto";
    };
  }, [isOpen]);

  return (
    <ModalWrapper isOpen={isOpen}>
      <ModalContent>
        <CloseButton
          onClick={() => {
            onClose();
            setIsOpen(false);
          }}
        >
          <img src={close} alt='close' />
        </CloseButton>
        {children}
      </ModalContent>
    </ModalWrapper>
  );
};

export default Modal;
